import { apiCalling, apiCallingWithoutToken } from "../apiService";

export async function getSiteData() {
  const urlParams = new URLSearchParams(window.location.search);
  let querySiteId = urlParams.get("siteid") || urlParams.get("siteId");

  if (!querySiteId) {
    const pathnameMatches = window.location.pathname.match(/\/?siteid-([0-9]+)/i);
    if (pathnameMatches && pathnameMatches[1]) {
      querySiteId = pathnameMatches[1];
    }
  }

  const isTargetSite = querySiteId;
  const jsonReq = {
    method: "POST",
    body: JSON.stringify({
      functionName: "getSiteDetails",
      siteId: isTargetSite ? isTargetSite : "",
      siteUrl: isTargetSite ? "" : window.location.host,
    }),
  };

  const data = await apiCallingWithoutToken(jsonReq);

  if (!data || data.success !== "1") {
    console.log("getSiteDetails API failed");
  }

  const siteData = data.siteDetailsData[0].siteData[0];

  // Determine folder/theme
  let is_theme_based = siteData.is_theme_based;
  let project_folder = siteData?.project_folder
    ? siteData.project_folder
    : "DoctorsCabin";

  var folder = "DoctorsCabin";
  if (is_theme_based === false && project_folder !== "") {
    folder = project_folder;
  } else {
    folder = siteData.themeName;
  }
  if (!siteData.id) {
    folder = "DoctorsCabin";
  }

  // Store all site details in sessionStorage
  window.sessionStorage.setItem("siteId", siteData.id);
  window.sessionStorage.setItem("themeId", siteData.themeId);
  window.sessionStorage.setItem("themeName", siteData.themeName);
  window.sessionStorage.setItem("themeVersion", "0");
  window.sessionStorage.setItem("homeName", folder);
  window.sessionStorage.setItem("reload", "1");
  window.sessionStorage.setItem("dashboard_html", siteData.dashboard_html);
  window.sessionStorage.setItem(
    "theme_custom_color",
    siteData.theme_custom_color,
  );
  window.sessionStorage.setItem("contact_emailId", siteData.emailId);
  window.sessionStorage.setItem("contact_no", siteData.contact_no);
  window.sessionStorage.setItem("fav_icon", siteData.fav_icon);
  window.sessionStorage.setItem("seo_description", siteData.seo_description);
  window.sessionStorage.setItem("seo_keywords", siteData.seo_keywords);
  window.sessionStorage.setItem("seo_title", siteData.seo_title);
  window.sessionStorage.setItem("slug", siteData.slug);
  window.sessionStorage.setItem("isIDALogin", siteData.isIDALogin);
  window.sessionStorage.setItem("siteName", siteData.siteName);
  window.sessionStorage.setItem(
    "book_appointment_terms",
    siteData.book_appointment_terms,
  );
  window.sessionStorage.setItem("video_chat_terms", siteData.video_chat_terms);
  window.sessionStorage.setItem(
    "hospital_working_time",
    siteData.hospital_working_time,
  );
  window.sessionStorage.setItem("site_url", siteData.site_url);
  window.sessionStorage.setItem("title", siteData.title);
  window.sessionStorage.setItem("fbPixel", siteData.fbPixel);
  window.sessionStorage.setItem(
    "advertisementScript",
    siteData.advertisementScript,
  );
  window.sessionStorage.setItem(
    "termsAndCondition",
    siteData.termsAndCondition,
  );
  window.sessionStorage.setItem("privacyPolicy", siteData.privacyPolicy);
  window.sessionStorage.setItem("hasHealthTracker", siteData.hasHealthTracker);
  window.sessionStorage.setItem("siteLogo", siteData.logo_path);
  window.sessionStorage.setItem(
    "google_review_link",
    siteData.google_review_link,
  );

  // Google analytics
  var google_analytics_script = siteData.google_analytics_script;
  var clarityId = "";
  var googleId = "";
  if (google_analytics_script && google_analytics_script.length < 30) {
    var Gdata = google_analytics_script.split(",");
    if (Gdata[0]) {
      googleId = Gdata[0];
    }
    if (Gdata[1]) {
      clarityId = Gdata[1];
    }
  }
  window.sessionStorage.setItem("clarityId", clarityId);
  window.sessionStorage.setItem("googleId", googleId);

  // Group hospital admin
  window.sessionStorage.setItem(
    "groupHospitalAdminId",
    data.siteDetailsData[0].groupHospitalAdminData[0]?.groupHospitalAdminId,
  );

  // Header & Footer
  window.sessionStorage.setItem(
    "headerData",
    JSON.stringify(data.siteDetailsData[0].headerData),
  );
  window.sessionStorage.setItem(
    "footerData",
    JSON.stringify(data.siteDetailsData[0].footerData),
  );

  // Services
  window.sessionStorage.setItem(
    "siteServices",
    JSON.stringify(data.siteDetailsData[0].services),
  );

  // Hospital data
  const hosDataVar = data.siteDetailsData[0].hospitalData;
  if (hosDataVar) {
    window.sessionStorage.setItem(
      "footerhospitalData",
      JSON.stringify(hosDataVar),
    );
    window.sessionStorage.setItem(
      "hospitalLocationCount",
      data.siteDetailsData[0].hospitalLocationCount,
    );
    window.sessionStorage.setItem(
      "footerHospitalName",
      hosDataVar.hospitalName,
    );
    window.sessionStorage.setItem("footerHospitalcity", hosDataVar.city);
    window.sessionStorage.setItem("footerHospitaladdress", hosDataVar.address);
    window.sessionStorage.setItem(
      "footerHospitalstateName",
      hosDataVar.stateName,
    );
    window.sessionStorage.setItem("footerHospitalzipCode", hosDataVar.zipCode);
  }

  // Theme sections
  if (data.siteDetailsData[0].themeSectionList) {
    for (let i = 0; i < data.siteDetailsData[0].themeSectionList.length; i++) {
      window.sessionStorage.setItem(
        data.siteDetailsData[0].themeSectionList[i].themeSectionName,
        JSON.stringify(
          data.siteDetailsData[0].themeSectionList[i].themeSectionContent,
        ),
      );
    }
  }

  // Doctor details
  window.sessionStorage.setItem(
    "doctorDetails",
    JSON.stringify(data.siteDetailsData[0].doctorDetails),
  );

  return siteData.id;
}
